import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero is-primary is-fullheight" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "columns is-centered" }
const _hoisted_5 = { class: "column is-5-tablet is-4-desktop is-4-widescreen" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "has-text-centered" }, " Se te olvido la contraseña? "),
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-justified" }, " Escribe tu email y envia el formulario. Luego, revisa tu bandeja de entrada en el correo y sigue los pasos. ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3",
  id: "recaptcha-notice"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "content" }, [
    /*#__PURE__*/_createTextVNode(" Este sitio esta protegido por reCaptcha y la "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://policies.google.com/privacy",
      class: ""
    }, "Política de Privacidad"),
    /*#__PURE__*/_createTextVNode(" y "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://policies.google.com/terms" }, "Condiciones del servicio"),
    /*#__PURE__*/_createTextVNode(" de Google aplican. ")
  ])
], -1)
const _hoisted_8 = { class: "columns mt-4" }
const _hoisted_9 = { class: "column" }
const _hoisted_10 = { class: "has-text-centered mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "has-hover" }, " Regresar al inicio de sesión! ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "divider my-0 is-vertical" }, " o ", -1)
const _hoisted_13 = { class: "column" }
const _hoisted_14 = { class: "has-text-centered mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "has-hover" }, " Regresar a la pagina principal! ", -1)

import { authService } from "@/services/auth";
import { ref, reactive, Ref, onMounted, readonly } from "vue";
import MessageNotificationList from "@/components/MessageNotificationList.vue";
import { useMessages } from "@/store/message";
import { testEmail } from "@/utils";
import { useGrecaptchaV2, useGrecaptchaV3 } from "@/composables/use-grecaptcha";
import FailedValidation from "@/error/api/failed-validation";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref("");
const msg = useMessages();
const isLoading = ref(false);

const reCaptcha: Ref<HTMLElement> = ref(null as unknown as HTMLDivElement);
const v2SiteKey = ref("");
onMounted(async () => {
  v2SiteKey.value = await authService.getReCaptchaV2SiteKey();
});
const requestType = readonly(ref("signup"));
const recaptcha = reactive({
  reCaptchaV2SiteKey: null as null | string,
  reCaptcheType: "v3" as "v2" | "v3",
  reCaptchaV2Token: "",
});

const V2 = useGrecaptchaV2(reCaptcha, v2SiteKey);
const V3 = useGrecaptchaV3(requestType);

const handleClick = async () => {
  if (!testEmail(email.value)) {
    msg.addError("El email suministrado no es evalido.", 7);
    return;
  }

  isLoading.value = true;
  try {
    let token_grecaptcha =
      recaptcha.reCaptcheType == "v3"
        ? await V3.validateV3recaptcha()
        : recaptcha.reCaptchaV2Token;

    await authService.forgotPassword(
      email.value,
      token_grecaptcha,
      recaptcha.reCaptcheType
    );
    msg.addSuccess(
      "Proceso para reestablecer la contraseña ha iniciado, revisa tu bandeja de email. Ya puedes cerrar esta ventana."
    );
    email.value = "";
  } catch (e) {
    // msg.addError(
    //   "No se ha iniciado el proceso de reestablecer contraseña. Verifica el email o intentelo más tarde."
    // ); // error generico para no rebelar info
    let message = "Intentelo de nuevo.";

    if (e instanceof FailedValidation) {
      const failures = new Map(Object.entries(e.failures));
      if (failures.has("recaptcha") && recaptcha.reCaptcheType == "v3") {
        recaptcha.reCaptcheType = "v2";
        message = "Complete el captcha.";
        V2.renderV2Recaptcha().then(
          (token: string) => (recaptcha.reCaptchaV2Token = token)
        );
        console.log("es error de rechaptcha");
      }
    }
    msg.addError(`Ha ocurrido un error. ${message} `);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              class: "box",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
            }, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                class: "input is-info",
                type: "text",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
              }, null, 512), [
                [_vModelText, email.value]
              ]),
              _hoisted_7,
              _createElementVNode("div", {
                ref_key: "reCaptcha",
                ref: reCaptcha,
                class: "field mt-3"
              }, null, 512),
              _createElementVNode("button", {
                class: _normalizeClass(["button is-link is-fullwidth mt-3", { 'is-loading': isLoading.value }]),
                onClick: handleClick
              }, " Enviar ", 2),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, [
                    _createVNode(_component_router_link, { to: { name: 'login' } }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", _hoisted_14, [
                    _createVNode(_component_router_link, { to: { name: 'home' } }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createVNode(MessageNotificationList)
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}
}

})